export default __webpack_public_path__ + "static/media/contentMobile.f52d867e.png";